import axios from 'axios';
export const submitForm = async (request_data) => {
  const response = await axios({
    ...request_data,
    auth: {
      username: 'ck_4e42008ab5b5f5575eeda5fd88d7235b8794a78f',
      password: 'cs_79c8f45973009f5bbdd68dfc45639997ebff51d7',
    }
  });
  return response;
};

export const phoneRegX = RegExp(/([+]?\d{1,2}[.-\s]?)?(\d{3}[.-]?){2}\d{4}/g);
export const emailRegX = RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
export const allowFileTypes = '.doc,.docx,.pdf,.xls,.xlsx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,image/png,image/jpeg,text/plain';

export const allowFileTypesCareer = '.doc,.docx,.pdf,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
